import React, { useEffect, useRef } from 'react'
import { useProjectFormStyles } from './project-form.styles'
import clsx from 'clsx'
import styles from './Editor.module.scss'

export const Editor = ({
  onChange,
  editorLoaded,
  name,
  value,
  disabled,
  error
}) => {
  const editorRef = useRef()
  const { CKEditor, ClassicEditor } = editorRef.current || {}
  const classes = useProjectFormStyles()

  useEffect(() => {
    editorRef.current = {
      /* eslint @typescript-eslint/no-var-requires: "off" */
      CKEditor: require('@ckeditor/ckeditor5-react').CKEditor,
      ClassicEditor: require('@ckeditor/ckeditor5-build-classic')
    }
  }, [])
  return (
    <div
      className={clsx(
        { [classes.editorValidationError]: error },
        classes.editorInput
      )}
    >
      {editorLoaded ? (
        <CKEditor
          type=""
          className={clsx(classes.editorInput, styles.editor)}
          disabled={disabled}
          name={name}
          editor={ClassicEditor}
          data={value}
          onChange={(_, editor) => onChange(editor.getData())}
        />
      ) : (
        <div>Editor loading</div>
      )}
    </div>
  )
}
